import {
  // useCallback,
  useRef,
  useState as classicUseState,
  useState,
} from 'react';

import { ReactComponent as ArrowRightImg } from '@assets/svg/arrow-right.svg';
import { ReactComponent as ArrowUpImg } from '@assets/svg/arrow-up.svg';
import { ReactComponent as CheckboxChecked } from '@assets/svg/checkbox-checked.svg';

import { DateInput, SearchBarExpansive } from '@components';
import {
  clearUpdates,
  updateUpdatesEndDate,
  updateUpdatesManufactorNames,
  updateUpdatesNinetyDays,
  updateUpdatesSixtyDays,
  updateUpdatesStartDate,
  // updateUpdatesTags,
  updateUpdatesThirtyDays,
} from '@store/redux/features/updates';
import { useAppDispatch, useAppSelector } from '@store/redux/store';

import {
  Buttons,
  Cancel,
  ConfirmButton,
} from '@components/Filters/Filter/components/FilterContent/FilterContent.styles';

import { useQuery } from 'react-query';

import { disableConfirmDate } from '@components/Filters/Filter/components/FilterContent/FilterContent.utils';
// import { SearchBarExpansiveTags } from '@components/SearchBars';

import { useSetState } from '@mantine/hooks';

import { getManufacturerNamesWSearch } from '@services/queries/manufacturers/getManufacturersNames/getManufacturerNamesWSearch';
import { DateFilters } from '@store/redux/features/filter/filterSlice';
import { updateUpdatesFilterDate } from '@store/redux/features/updates/updatesSlice';
import { sortStr } from '@utils/sorting/non-ascii';
import { BActionIcon } from '@components/BActionIcon/BActionIcon';
// import { TagsFilter } from '@components/Filters/Filter/components/FilterContent/TagsFilter';
// import { getTagsCategory } from '@services/queries/tagsCategory/getTagsCategory/getTagsCategory';
// import { noop } from '@pages/Asset/components/Sidebar/components/Data/components/UnEditableField/UnEditableField.utils';
// import { OnTagFilterChange } from '@components/Filters/Filter/components/FilterContent/OnTagFilterChange';
// import { TagsFilterProps } from '@components/Filters/Filter/components/FilterContent/TagsFilter/types';
import {
  Checkbox,
  Container,
  Divider,
  Header,
  OptionsButton,
  OptionsDiv,
  Row,
  Title,
} from './MenuContent.styles';

interface IAddFieldContent {
  setOpenMenu: (bool: boolean) => void;
  filterCount: number;
  startSearch: () => void;
}

const INTERNAL_MANUFACTURER = 'INTERNAL';
const MenuContent = ({
  setOpenMenu,
  filterCount,
  startSearch,
}: IAddFieldContent) => {
  const { updates } = useAppSelector();
  const haveDateFilter =
    updates.options.checkSixtyDays ||
    updates.options.checkNinetyDays ||
    updates.options.checkThirtyDays ||
    updates.options.endDate ||
    updates.options.startDate;
  const [openDate, setOpenDate] = useState<boolean>(
    !(haveDateFilter === undefined || haveDateFilter === null),
  );
  const [searchTextManufactor, setSearchTextManufactor] = classicUseState('');
  const [openManufacturer, setOpenManufacturer] = useState<boolean>(
    updates.options.manufactorNames.length > 0,
  );
  // const [openTag, setOpenTag] = useState<boolean>(
  //   updates.options.tags.length > 0,
  // );
  const [manufactorNames, setManufactorNames] = classicUseState<string[]>([]);
  const [loadingSearchManufactor, setLoadingSearchManufactor] =
    classicUseState(false);
  const [alreadySearchManufactor, setAlreadySearchManufactor] =
    classicUseState(false);
  const [showErasedSearchManufactor, setShowErasedManufactor] =
    classicUseState(false);
  // const [tagSearch, setTagSearch] = useSetState({
  //   tagSearchText: '',
  //   tagQuerySearch: '',
  // });

  // const [loadingSearchTag, setLoadingSearchTag] = classicUseState(false);
  // const [alreadySearchTag, setAlreadySearchTag] = classicUseState(false);
  // const [showErasedSearchTag, setShowErasedTag] = classicUseState(false);
  const [localDateFilter, setLocalDateFilter] = useSetState<DateFilters>({
    startDate: updates.options.startDate ?? null,
    endDate: updates.options.endDate ?? null,
  });

  const [manufacturerQueryTerm, setManufacturerQueryTerm] = classicUseState('');
  const dispatch = useAppDispatch();

  const searchFuncManufactor = (input: string) => {
    setShowErasedManufactor(false);
    setSearchTextManufactor(input);
  };
  // Separates loading query from loading of component so it's easier to refactor.
  const waitingForManufacturer = useRef(false);

  // todo: use query return value
  useQuery(
    ['get', 'manufacturerNames', manufacturerQueryTerm],
    getManufacturerNamesWSearch,
    {
      enabled: waitingForManufacturer.current,
      onSuccess: result => {
        setLoadingSearchManufactor(false);
        setShowErasedManufactor(true);
        setAlreadySearchManufactor(true);
        const mans = result.map(item => item.name);
        const matchesInternal = INTERNAL_MANUFACTURER.toLowerCase().includes(
          manufacturerQueryTerm.toLowerCase(),
        );
        if (matchesInternal) {
          mans.push(INTERNAL_MANUFACTURER);
          // SORT too
          mans.sort(sortStr);
        }
        setManufactorNames(mans);
        waitingForManufacturer.current = false;
      },
    },
  );
  // const tagsQuery = useQuery(
  //   ['tagCategories', tagSearch.tagQuerySearch],
  //   () =>
  //     getTagsCategory({
  //       search: tagSearch.tagQuerySearch,
  //     }),
  //   {
  //     onSuccess: () => {
  //       setLoadingSearchTag(false);
  //       setShowErasedTag(true);
  //       setAlreadySearchTag(true);
  //     },
  //   },
  // );
  // const { data = [], isLoading } = tagsQuery;

  // const startSearchTag = () => {
  //   setLoadingSearchTag(true);
  //   setTagSearch(prev => {
  //     return { tagQuerySearch: prev.tagSearchText };
  //   });
  // };

  const startSearchManufactor = (input: string) => {
    if (input === '') return;
    setLoadingSearchManufactor(true);
    waitingForManufacturer.current = true;
    setManufacturerQueryTerm(input);
  };

  const onPressEnterManufactor = (event: any) => {
    if (event.key === 'Enter') {
      startSearchManufactor(searchTextManufactor);
    }
  };

  // const onPressEnterTag = (event: any) => {
  //   if (event.key === 'Enter') {
  //     startSearchTag();
  //   }
  // };

  // const searchFuncTag = (input: string) => {
  //   setShowErasedTag(false);
  //   setTagSearch({ tagSearchText: input });
  // };

  // const onTagFilterChange: TagsFilterProps['onTagFilterChange'] = useCallback(
  //   OnTagFilterChange(updates.options.tags, filtered => {
  //     dispatch(updateUpdatesTags(filtered));
  //     startSearch();
  //   }),
  //   [dispatch, updates.options.tags],
  // );

  return (
    <Container
      aria-orientation="vertical"
      maxHeight="var(--max-height)"
      offsetScrollbars
    >
      <Header>
        <Title>Filter</Title>
        <BActionIcon
          onClick={() => {
            setOpenMenu(false);
          }}
          icon="cross"
        />
      </Header>

      <Row onClick={() => setOpenDate(!openDate)}>
        <Title className="label">Date</Title>
        {openDate ? (
          <>
            <ArrowUpImg />
          </>
        ) : (
          <>
            <ArrowRightImg />
          </>
        )}
      </Row>

      {openDate && (
        <>
          <Divider height="16px" />
          <Title className="small-label">Quick options</Title>

          <Divider height="8px" />

          <OptionsButton
            onClick={() => {
              dispatch(
                updateUpdatesThirtyDays(!updates.options.checkThirtyDays),
              );
              dispatch(updateUpdatesSixtyDays(false));
              dispatch(updateUpdatesNinetyDays(false));
              dispatch(updateUpdatesStartDate(null));
              dispatch(updateUpdatesEndDate(null));
              startSearch();
            }}
          >
            <OptionsDiv>
              <Checkbox checked={updates.options.checkThirtyDays}>
                {updates.options.checkThirtyDays ? (
                  <CheckboxChecked width="16px" height="16px" />
                ) : (
                  ''
                )}
              </Checkbox>
              <Title className="options">Last 30 days</Title>
            </OptionsDiv>
          </OptionsButton>

          <OptionsButton
            onClick={() => {
              dispatch(updateUpdatesThirtyDays(false));
              dispatch(updateUpdatesSixtyDays(!updates.options.checkSixtyDays));
              dispatch(updateUpdatesNinetyDays(false));
              dispatch(updateUpdatesStartDate(null));
              dispatch(updateUpdatesEndDate(null));
              startSearch();
            }}
          >
            <OptionsDiv>
              <Checkbox checked={updates.options.checkSixtyDays}>
                {updates.options.checkSixtyDays ? (
                  <CheckboxChecked width="16px" height="16px" />
                ) : (
                  ''
                )}
              </Checkbox>
              <Title className="options">Last 60 days</Title>
            </OptionsDiv>
          </OptionsButton>

          <OptionsButton
            onClick={() => {
              dispatch(updateUpdatesThirtyDays(false));
              dispatch(updateUpdatesSixtyDays(false));
              dispatch(
                updateUpdatesNinetyDays(!updates.options.checkNinetyDays),
              );
              dispatch(updateUpdatesStartDate(null));
              dispatch(updateUpdatesEndDate(null));
              startSearch();
            }}
          >
            <OptionsDiv>
              <Checkbox checked={updates.options.checkNinetyDays}>
                {updates.options.checkNinetyDays ? (
                  <CheckboxChecked width="16px" height="16px" />
                ) : (
                  ''
                )}
              </Checkbox>
              <Title className="options">Last 90 days</Title>
            </OptionsDiv>
          </OptionsButton>

          <Divider height="16px" />
          <Title className="date-labels">From</Title>
          <Divider height="8px" />
          <DateInput
            width={264}
            height={42}
            handleDateChange={e => {
              let startDate: Date | null = null;
              if (e) startDate = new Date(e);

              setLocalDateFilter({
                startDate,
              });
            }}
            value={localDateFilter.startDate}
            maxDate={localDateFilter.endDate ?? undefined}
          />

          <Divider height="16px" />
          <Title className="date-labels">To</Title>
          <Divider height="8px" />
          <DateInput
            width={264}
            height={42}
            handleDateChange={e => {
              let endDate: Date | null = null;
              if (e) endDate = new Date(e);
              setLocalDateFilter({
                endDate,
              });
            }}
            value={localDateFilter.endDate}
            minDate={localDateFilter.startDate ?? undefined}
          />
          <Buttons>
            <ConfirmButton
              disabled={disableConfirmDate(localDateFilter, updates.options)}
              onClick={() => {
                dispatch(updateUpdatesFilterDate(localDateFilter));
                startSearch();
              }}
              className="with-margin"
            >
              Confirm
            </ConfirmButton>
          </Buttons>
          <Divider height="16px" />
        </>
      )}
      <Row onClick={() => setOpenManufacturer(!openManufacturer)}>
        <Title className="label">From</Title>
        {openManufacturer ? <ArrowUpImg /> : <ArrowRightImg />}
      </Row>

      {openManufacturer && (
        <>
          <Divider height="16px" />
          <SearchBarExpansive
            showOptions={manufactorNames}
            setShowOptions={setManufactorNames}
            searchText={searchTextManufactor}
            placeholder="Find a Source"
            loadingSearch={loadingSearchManufactor}
            alreadySearch={alreadySearchManufactor}
            showErasedSearch={showErasedSearchManufactor}
            searchOnKeyDown={onPressEnterManufactor}
            searchIconOnClick={() =>
              startSearchManufactor(searchTextManufactor)
            }
            closeIconOnClick={() => {
              setSearchTextManufactor('');
            }}
            searchOnChange={searchFuncManufactor}
            onClickFilter={input => {
              const newFilterData = [...updates.options.manufactorNames];
              const filterExist = newFilterData.find(item =>
                item.name.match(input),
              );
              if (!filterExist) {
                newFilterData.push({ name: input, active: true });
                dispatch(updateUpdatesManufactorNames(newFilterData));
                startSearch();
              }
              setManufactorNames([]);
            }}
          />

          {updates.options.manufactorNames.length > 0 && (
            <Divider height="16px" />
          )}

          <OptionsButton>
            {updates.options.manufactorNames.map(manufactor => (
              <OptionsDiv
                onClick={() => {
                  const newFilterData = [...updates.options.manufactorNames];
                  const index = newFilterData.indexOf(manufactor);
                  if (index !== -1) {
                    const oldManufacturerName = newFilterData[index];
                    newFilterData[index] = {
                      name: oldManufacturerName.name,
                      active: !oldManufacturerName.active,
                    };
                    dispatch(updateUpdatesManufactorNames(newFilterData));
                    startSearch();
                  }
                }}
              >
                <Checkbox checked={manufactor.active}>
                  {manufactor.active ? (
                    <CheckboxChecked width="16px" height="16px" />
                  ) : (
                    ''
                  )}
                </Checkbox>
                <Title className="options">{manufactor.name}</Title>
              </OptionsDiv>
            ))}
          </OptionsButton>
          <Divider height="16px" />
        </>
      )}

      {/* <Row onClick={() => setOpenTag(!openTag)}>
        <Title className="label">Tag</Title>
        {openTag ? <ArrowUpImg /> : <ArrowRightImg />}
      </Row>
      {openTag && (
        <>
          <Divider height="16px" />
          <SearchBarExpansiveTags
            showOptions={[]}
            setShowOptions={noop}
            searchText={tagSearch.tagSearchText}
            placeholder="Find a Tag"
            loadingSearch={loadingSearchTag || isLoading}
            alreadySearch={alreadySearchTag}
            showErasedSearch={showErasedSearchTag}
            searchOnKeyDown={onPressEnterTag}
            searchIconOnClick={() => startSearchTag()}
            closeIconOnClick={() => {
              setTagSearch({ tagSearchText: '' });
            }}
            searchOnChange={searchFuncTag}
            onClickFilter={noop}
          />
          {data.length > 0 && <Divider height="8px" />}
          <TagsFilter
            categories={data}
            selectedTags={updates.options.tags}
            onTagFilterChange={onTagFilterChange}
          />
          <Divider height="16px" />
        </>
      )} */}
      <Buttons>
        <Cancel
          disabled={filterCount === 0}
          onClick={() => {
            dispatch(clearUpdates());
            startSearch();
            setOpenMenu(false);
          }}
        >
          Clear All
        </Cancel>
      </Buttons>
    </Container>
  );
};

export { MenuContent };
